import { createContext } from "react";

import type { ChainData } from "./hooks/data";
import type { Dispatch, State } from "./state";

type ContextData = Partial<
  State & ChainData & { address: `0x${string}`; dispatch: Dispatch }
>;

const TradeContext = createContext<ContextData>({});

export default TradeContext;
